<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-face-agent" icon-small title="لیست بازاریاب ها" color="accent">
			<template v-slot:topActions>
				<v-btn color="primary hidden-sm-and-down" dark class="mx-1" @click="add">
					<v-icon dark>
						mdi-plus-circle-outline
					</v-icon>
					افزودن بازاریاب
				</v-btn>
				<v-menu class="hidden-md-and-up">
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-bind="attrs" v-on="on" class="hidden-md-and-up">
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item link>
							<v-list-item-title @click="add">افزودن بازاریاب</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
			<div cols="12" class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table dense :headers="headers" :loading="loading" :items="marketers" :footer-props="{'items-per-page-options': [5, 15, 50, 100]}" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item.fullName="{item}">
								<a href="javascript:void(0)" @click="edit(item)" class="info--text">{{ item.fullName }}</a>
							</template>
							<template v-slot:item.lastLoginDate_Persian="{ item }">
								<div class="ltr">
									{{ `${item.lastLoginDate_Persian.date} ${item.lastLoginDate_Persian.time}` }}
								</div>
							</template>
							<template v-slot:item.totalReceives="{item}">
								<div @click="transactionList(item)" class="info--text" style="cursor: pointer;">
									{{ item.totalReceives.toString().toPriceFormat() }}
								</div>
							</template>
							<template v-slot:item.totalCommission="{item}">
								<div @click="commissionsList(item)" class="info--text" style="cursor: pointer;">
									{{ item.totalCommission.toString().toPriceFormat() }}
								</div>
							</template>
							<template v-slot:item.registerCount="{item}">
								<div @click="membersList(item)" class="info--text" style="cursor: pointer;">
									{{ item.registerCount }}
								</div>
							</template>
							<template v-slot:item.loanRequestCount="{item}">
								<div @click="loanRequestsList(item)" class="info--text" style="cursor: pointer;">
									{{ item.loanRequestCount }}
								</div>
							</template>
							<template v-slot:item.userLoanCounts="{item}">
								{{ item.userLoanCounts }}
							</template>
							<template v-slot:item.phone="{item}">
								{{ (item.totalCommission - item.totalReceives).toString().toPriceFormat() }}
							</template>
							<template v-slot:item.isActive="{ item }">
								<v-icon v-if="item.isActive" color="success" title="غیرفعال">
									mdi-check-circle
								</v-icon>
								<v-icon v-else color="error" title="فعال">
									mdi-close-circle
								</v-icon>
							</template>
							<template v-slot:item.operations="{item}">
								<div class="text-center">
									<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
								</div>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
			<v-dialog v-model="dialogMarketer" scrollable persistent max-width="700px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات بازاریاب</span>
						<v-spacer />
						<v-btn @click="dialogMarketer = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<ModifyMarketer :data="selectedMarketer" v-if="dialogMarketer" @callbck="callbck" />
						</v-container>
					</v-card-text>

				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogLoanRequestsList" scrollable max-width="1400px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست درخواست وام های {{ selectedMarketer.businessName }}</span></div>
						<v-spacer />
						<v-btn @click="dialogLoanRequestsList = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<UserLoanRequests v-if="dialogLoanRequestsList" :data="{member:selectedMarketer}" :marketer="selectedMarketer" @update="loadData" />
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogCommissionsList" scrollable max-width="1400px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست پرونده های وام {{ selectedMarketer.businessName }}</span></div>
						<v-spacer />
						<v-btn @click="dialogCommissionsList = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<Commissions v-if="dialogCommissionsList" :data="{member:selectedMarketer}" :marketer="selectedMarketer" @update="loadData" />
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogMarketerTransactionsList" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست واریز ها به {{ selectedMarketer.businessName }}</span></div>
						<v-spacer />
						<v-btn @click="dialogMarketerTransactionsList = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<MarketerTransactions v-if="dialogMarketerTransactionsList" :marketer="selectedMarketer" @update="loadData" />
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogMembersList" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست ثبت نامی های {{ selectedMarketer.businessName }}</span></div>
						<v-spacer />
						<v-btn @click="dialogMembersList = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<MarketerMembers v-if="dialogMembersList" :marketer="selectedMarketer" @update="loadData" />
					</v-card-text>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'CustomerMarketers',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyMarketer: () => import('@/views/admin/marketer/ModifyMarketer'),
			Commissions: () => import('./Commissions.vue'),
			ModifyMarketer: () => import('./ModifyMarketer.vue'),
			MarketerTransactions: () => import('./MarketerTransactions.vue'),
			MarketerMembers: () => import('./MarketerMembers.vue'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedMarketer: {},
				dialogMarketer: false,
				dialogLoanRequestsList: false,
				dialogMembersList: false,
				dialogCommissionsList: false,
				dialogMarketerTransactionsList: false,
				dialogCommissionsList: false,
				search: '',
				loading: false,
				headers: [
					{
						text: 'نام بازاریاب',
						align: 'start',
						sortable: true,
						value: 'fullName',
						width: 125
					}, {
						text: 'نام تجاری',
						align: 'start',
						sortable: true,
						value: 'businessName',
						width: 125
					}, {
						text: 'نام کاربری',
						align: 'start',
						sortable: true,
						value: 'userName',
						width: 175
					}, {
						text: 'کد بازاریابی',
						align: 'center',
						sortable: true,
						value: 'affiliateCode',
					}, {
						text: 'تعداد ارجاعی به سایت',
						align: 'center',
						sortable: true,
						value: 'reffererCount',
						width: 125
					}, {
						text: 'منتهی به ثبت نام',
						align: 'center',
						sortable: true,
						value: 'registerCount',
						width: 125
					}, {
						text: 'منتهی به درخواست وام',
						align: 'center',
						sortable: true,
						value: 'loanRequstCounts',
						width: 140
					}, {
						text: 'منتهی به پرداخت وام',
						align: 'center',
						sortable: true,
						value: 'userLoanCounts',
						width: 130
					}, {
						text: 'مجموع پورسانت ها',
						align: 'center',
						sortable: true,
						value: 'totalCommission',
						width: 125
					}, {
						text: 'تسویه شده',
						align: 'center',
						sortable: true,
						value: 'totalReceives',
						width: 125
					}, {
						text: 'مانده تسویه نشده',
						align: 'center',
						sortable: true,
						value: 'phone',
						width: 125
					}, {
						text: 'آخرین ورود',
						align: 'center',
						sortable: true,
						value: 'lastLoginDate_Persian',
						width: 125
					}, {
						text: 'اکانت فعال',
						align: 'center',
						sortable: true,
						value: 'isActive',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 135,
					},
				],
				marketers: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/customermarketer/list', null)
					.then(
						response => {
							this.marketers = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			add() {
				this.selectedMarketer = { id: 0 }
				this.dialogMarketer = true
			},
			edit(item) {
				this.selectedMarketer = item
				this.dialogMarketer = true
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/customermarketer/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			callbck(result) {
				this.dialogMarketer = false
				if (result)
					this.loadData(true)
			},
			loanRequestsList(item) {
				this.selectedMarketer = item
				this.dialogLoanRequestsList = true
			},
			membersList(item) {
				this.selectedMarketer = item
				this.dialogMembersList = true
			},
			transactionList(item) {
				this.selectedMarketer = item
				this.dialogMarketerTransactionsList = true
			},
			commissionsList(item) {
				this.selectedMarketer = item
				this.dialogCommissionsList = true
			}

		},
	}
</script>
<style>
</style>
